import {fetchCalendarInvite} from '../util/cases';
import {downloadFile} from '../util/util';
import {useCallback} from 'react';

export const useAddToCalendar = (caseId: string) => {
    return useCallback(() => {
        fetchCalendarInvite(caseId).then((blob: any) => {
            if (blob && blob.type === 'text/calendar') {
                downloadFile(blob, 'invite.ics');
            }
        }).catch((err) => {
            console.error(err);
        })
    }, [caseId]);
}
